import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { useWindowWidth } from 'spa/hooks/useWindowWidth'
import { breakpointsV2 } from 'spa/config/styled'

import logo from 'images/common/logo.svg'
import styles from './ProductHeader.module.scss'
import { MaterialSymbol } from '../../MaterialSymbol'
import { useClickAway } from 'react-use'
import { Button } from 'spa/member/components/v2/Button'

export const StyledProductHeader: React.FC = () => {
  const windowWidth = useWindowWidth()
  const [isOpen, setIsOpen] = useState<boolean>(null)

  const toggleMenu = () => setIsOpen(!isOpen)

  const HeaderLinks = () => {
    return (
      <ul className={`${styles.nav}`}>
        <li className={`ml-2XL ${styles.navList}`}>
          <a className={`${styles.navLink}`} href="/#service-features">サービスの特徴</a>
        </li>
        <li className={`ml-XL ${styles.navList}`}>
          <a className={`${styles.navLink}`} href="/#service-flow">ご利用の流れ</a>
        </li>
        <li className={`ml-XL ${styles.navList}`}>
          <a className={`${styles.navLink}`} href="/#service-faq">よくある質問</a>
        </li>
        <li className={`ml-XL ${styles.navList}`}>
          <a className={`${styles.navLink}`} href="/#service-info">お役立ち情報</a>
        </li>
        <li className={`ml-XL ${styles.navList}`}>
          <NavLink className={`${styles.navLink}`} to="/job_offers">募集案件</NavLink>
        </li>
      </ul>
    )
  }

  const DropdownMenu = () => {
    const dropdownMenu = React.useRef<HTMLDivElement>(null)
    const handleClickOutside = () => setIsOpen(false)
    // Only the 'click' event is passed to prevent the dropdown menu from closing during touch scrolling.
    useClickAway(dropdownMenu, handleClickOutside, ['click'])

    return (
      <div className={`${styles.sideBar}`} style={{ display: isOpen ? 'block' : 'none' }} ref={dropdownMenu}>
        <ul className={`${styles.sideBarNav}`}>
          <li className={`${styles.sideBarNavList}`}>
            <a className={`flex justify-between p-M ${styles.sidebarNavLink}`} href="/#service-features">
              <div className="flex-grow">サービスの特徴</div>
              <div className="flex justify-center items-center">
                <MaterialSymbol name="arrow_forward_ios" size="14px" className={styles.arrowIcon} />
              </div>
            </a>
          </li>
          <li className={`${styles.sideBarNavList}`}>
            <a className={`flex justify-between p-M ${styles.sidebarNavLink}`} href="/#service-flow">
              <div className="flex-grow">ご利用の流れ</div>
              <div className="flex justify-center items-center">
                <MaterialSymbol name="arrow_forward_ios" size="14px" className={styles.arrowIcon} />
              </div>
            </a>
          </li>
          <li className={`${styles.sideBarNavList}`}>
            <a className={`flex justify-between p-M ${styles.sidebarNavLink}`} href="/#service-faq">
              <div className="flex-grow">よくある質問</div>
              <div className="flex justify-center items-center">
                <MaterialSymbol name="arrow_forward_ios" size="14px" className={styles.arrowIcon} />
              </div>
            </a>
          </li>
          <li className={`${styles.sideBarNavList}`}>
            <a className={`flex justify-between p-M ${styles.sidebarNavLink}`} href="/#service-info">
              <div className="flex-grow">お役立ち情報</div>
              <div className="flex justify-center items-center">
                <MaterialSymbol name="arrow_forward_ios" size="14px" className={styles.arrowIcon} />
              </div>
            </a>
          </li>
          <li className={`${styles.sideBarNavList}`}>
            <NavLink className={`flex justify-between p-M ${styles.sidebarNavLink}`} to="/job_offers">
              <div className="flex-grow">募集案件</div>
              <div className="flex justify-center items-center">
                <MaterialSymbol name="arrow_forward_ios" size="14px" className={styles.lastArrowIcon} />
              </div>
            </NavLink>
          </li>
        </ul>
      </div>
    )
  }

  const ButtonGroup = () => {
    return (
      <div className={`select-none desktop:select-auto ${styles.buttonGroup}`}>
        {windowWidth >= breakpointsV2.desktop && (
          <a href="/signup">
            <Button kind="danger" link>無料登録する</Button>
          </a>
        )}
        {windowWidth >= breakpointsV2.desktop && (
          <a href="/login">
            <Button kind="secondary" link>ログインする</Button>
          </a>
        )}
        {windowWidth >= breakpointsV2.desktop ?
          '' :
          <div className={`flex ${styles.menuIconArea}`}
            onClick={toggleMenu}
            aria-expanded={isOpen}
          >
            <MaterialSymbol name={isOpen ? 'close' : 'menu'} size="32px" className={styles.menuIcon} />
            {isOpen !== null && windowWidth < breakpointsV2.desktop && <DropdownMenu />}
          </div>
        }
      </div>
    )
  }

  return (
    <header className={`border-b-1 border-member-gray-20 px-XL py-M desktop:px-S desktop:pl-4XL ${styles.productHeaderContainer}`}>
      <h1>
        <a className={`${styles.logo}`} data-cy='job-offers-header-logo' href="/">
          <img src={logo} alt="フリーランス求人・業務委託の案件情報が満載" />
        </a>
      </h1>
      <HeaderLinks />
      <ButtonGroup />
    </header>
  )
}
